'use strict';

// Constructor
var MegaMenu = function () {
    // Make all the sub level a none tabbable unless active
    $('#block-act-health-public-website-main-menu .level-1 a').attr('tabindex', -1);
    
    // Add aria expanded false
    $('#block-act-health-public-website-main-menu .level-0 > li > a').attr('aria-expanded', 'false');
    $('#block-act-health-public-website-main-menu .level-1').attr('aria-hidden', 'true');

    // Clicking on the first level NAV toggles the mega menu
    $('#block-act-health-public-website-main-menu .level-0 > li > a').click(function ($event) {
        $event.preventDefault();
        var $sub_menu = $(this).siblings('div');
        var $the_link = $(this);

        if ($sub_menu.length > 0) {
            // If there are sub menu items
            setTimeout(function () {
                $('#block-act-health-public-website-main-menu .level-1').removeClass('active');
                $('#block-act-health-public-website-main-menu .level-1').attr('aria-hidden', 'true');
                $('#block-act-health-public-website-main-menu .level-0 > li > a').attr('aria-expanded', 'false');
                $($the_link).attr('aria-expanded', 'true');
                $sub_menu.toggleClass('active');

                // Make elements in the mega menu same height,  first remove the other height
                $('.level-1 .menu_highlight_wrapper').removeAttr('style');
                $('.level-1 .tertiary_highlight').removeAttr('style');
                $('.level-1.active .menu_highlight_wrapper').matchHeight({byRow: false});
                $('.level-1.active .tertiary_highlight').matchHeight();

                // If the menu is open the make the sub links tabb-able
                if ($sub_menu.hasClass('active')) {
                    $sub_menu.find('a').attr('tabindex', '');
                    $sub_menu.attr('aria-hidden', 'false');
                } else {
                    $sub_menu.find('a').attr('tabindex', -1);
                    $sub_menu.attr('aria-hidden', 'true');
                }
            }, 50);
        } else {
            // If not submenu items then just load the page
            window.location.href = $(this).attr('href');
        }

    });

    // Clicking on anything else closes the mega menu
    $('#block-act-health-public-website-main-menu .level-0 a').focusout(function () {
        setTimeout(function () {
            if (!$('#block-act-health-public-website-main-menu .level-1 a:focus').length) {
                $('#block-act-health-public-website-main-menu .level-1').removeClass('active');
                $('#block-act-health-public-website-main-menu .level-1 a').attr('tabindex', -1);
                $('#block-act-health-public-website-main-menu .level-0 > li > a').attr('aria-expanded', 'false');
                $('#block-act-health-public-website-main-menu .level-1').attr('aria-hidden', 'true');
            }
        }, 50);
    });

    // Pressing escape key also closes the mega menu
    $(document).keyup(function (e) {
        if (e.keyCode === 27) { // escape key maps to keycode `27`
            $('#block-act-health-public-website-main-menu .level-1').removeClass('active');
            $('#block-act-health-public-website-main-menu .level-1 a').attr('tabindex', -1);
        }
    });
};

module.exports = MegaMenu;
